export default __webpack_public_path__ + "static/media/61_Random_RotateLeft.363d6912.mp4";